/**
 * WorkspaceContext: state shared across every section page in the HR
 * workspace. Lives at the AppWorkspace shell level — children read it via
 * useWorkspace() rather than refetching the app metadata themselves.
 *
 * Shape:
 *   {
 *     app:           { id, type, name, myRole, iAmOwner, createdAt },
 *     myRole:        'super_admin' | 'admin' | 'member',
 *     canWrite:      boolean,           // role !== 'member'
 *     canManage:     boolean,           // role === 'super_admin'
 *     organisation:  { ...row from /hr/organisation }  (cached; refresh after edit)
 *     refreshOrganisation: () => Promise<void>,
 *     searchQuery:   string,            // global search term from navbar
 *     setSearchQuery: (q: string) => void,
 *   }
 */

import { createContext, useContext } from 'react';

export const WorkspaceContext = createContext(null);

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) {
    throw new Error('useWorkspace() must be used inside <AppWorkspace />');
  }
  return ctx;
}
